export enum EventStatus {
	PENDING = "PENDING",
	PENDING_APPROVAL_WITH_ADMIN = "PENDING_APPROVAL_WITH_ADMIN",
	DRAFT = "DRAFT",
	PUBLISHED = "PUBLISHED",
	ARCHIVED = "ARCHIVED",
	REJECTED = "REJECTED",
	REMOVED = "REMOVED",
}
